export const DEFAULT_TRANSLATIONS = {
  quantity: 'Quantity',
};
